import Heading from '@/common/shared/heading'
import UpdateRankForm from '../UpdateRankForm'
import { Separator } from '@/common/ui/separator'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function UpdateRankListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`แก้ไขรายการแรงค์`} description="แก้ไขรายการแรงค์" />
				<NavigateBackButton />
			</div>
			<Separator />
			<UpdateRankForm />
		</div>
	)
}
